
import React from 'react';

class ContactForm extends React.Component {
  state = { name: '', contact: '', message: '', formInfo: '' };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // You can add your form submission logic here
    this.setState({ formInfo: 'Kiitos viestistä!' });
  };

  render() {
    return (
      <form className="contact-form" onSubmit={this.handleSubmit}>
        <input
          className="contact-input"
          type="text"
          name="name"
          placeholder="Nimi"
          value={this.state.name}
          onChange={this.handleChange}
        />
        <input
          className="contact-input"
          type="text"
          name="contact"
          placeholder="Sähköposti tai puhelin"
          value={this.state.contact}
          onChange={this.handleChange}
        />
        <textarea
          className="contact-textarea"
          name="message"
          placeholder="Viesti"
          value={this.state.message}
          onChange={this.handleChange}
        />
        <button className="contact-submit" type="submit">Lähetä</button>
        {this.state.formInfo && <div className="contact-form-message">{this.state.formInfo}</div>}
      </form>
    );
  }
}

export default ContactForm;
